export default {
  namespaced: true,
  state: {
    // https://stripe.com/docs/stripe-js/elements/payment-request-button#html-js-create-payment-request-instance
    paymentRequestParams: {},
    createSubscriptionParams: {},
    // 'subscription' | 'charge',
    paymentFlow: '',
  },
  mutations: {
    setPaymentRequestParams(state, payload) {
      state.paymentRequestParams = payload;
    },
    setCreateSubscriptionParams(state, payload) {
      state.createSubscriptionParams = payload;
    },
    setPaymentFlow(state, flow) {
      state.paymentFlow = flow;
    },
  },
  getters: {
    paymentRequestParams: state => state.paymentRequestParams,
    createSubscriptionParams: state => state.createSubscriptionParams || {},
    paymentFlow: state => state.paymentFlow,
  },
};
